const ROOT_SELECTOR = '.js-background-animation';
let isInitialized = false;
let canvasElement = null;
let animationContainer = null;
let overlayContainer = null;
let exportRoot = null;
let stage = null;
let compositionId = '1AD25C96FBD8418D8F51F8DA041220C8';

function initBackgroundAnimation() {
  if (isInitialized) {
    return;
  }

  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) {
    return;
  }

  compositionId = root.getAttribute('data-background-animation-comp-id') || compositionId;

  canvasElement = document.getElementById('background-animation-canvas');
  animationContainer = document.getElementById('background-animation-container');
  overlayContainer = document.getElementById('background-animation-overlay');

  if (!canvasElement || !animationContainer || !overlayContainer) {
    return;
  }

  if (typeof window.createjs === 'undefined' || typeof window.AdobeAn === 'undefined') {
    console.warn('CreateJS or AdobeAn is not available.');
    return;
  }

  const composition = window.AdobeAn.getComposition(compositionId);
  if (!composition) {
    console.warn('Adobe Animate composition not found.', compositionId);
    return;
  }

  handleComplete({}, composition);
  isInitialized = true;
}

function handleComplete(evt, comp) {
  const lib = comp.getLibrary();
  
  exportRoot = new lib.main_back();
  stage = new lib.Stage(canvasElement);
  
  // makeResponsiveがstageをグローバル変数として参照するため、window.stageに設定（canvas_sample2と同じ）
  window.stage = stage;
  
  // makeResponsiveの後にアニメーションを開始（canvas_sample2と同じ順序）
  function fnStartAnimation() {
    stage.addChild(exportRoot);
    window.createjs.Ticker.framerate = lib.properties.fps;
    window.createjs.Ticker.addEventListener('tick', stage);
  }
  
  // Code to support hidpi screens and responsive scaling.
  window.AdobeAn.makeResponsive(true, 'width', false, 2, [canvasElement, animationContainer, overlayContainer]);
  window.AdobeAn.compositionLoaded(lib.properties.id);
  fnStartAnimation();
}


function ready(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
}

ready(initBackgroundAnimation);
window.addEventListener('load', initBackgroundAnimation);

